const Heading = ({ title, id }: { title: any; id?: any }) => {
  return (
    <label
      className=" text-[14px] text-[#464E5F]  font-semibold inline-block mb-0 py-1"
      htmlFor={id}
    >
      {title}
    </label>
  );
};

export default Heading;
